import { FeErrorCode } from './errorCodes.ts';

export type ErrorCause = Record<string, unknown> | undefined;

export const buildAppError = (code: FeErrorCode, cause?: ErrorCause) => {
  const e = new Error(code);
  e.name = code;
  e.cause = cause;

  return e;
};
